import moment from 'moment';
/**
 * typecript schema for future use
 * {
 *  options: string
 *  isDashboard: boolean,
 *  startValue: number,
 *  timeUnit: string,
 *  startKey:  Record<string, string>
 * }
 *
 * startKey usually looks like:
 *  { 'key': string } or, if isDashboard === true, { 'date_type': string }
 *
 */
const getEndDateRangeValue = ({ endValue, endTimeUnit, defaultEnd }) => {
    return endValue && endTimeUnit
        ? moment().add(endValue, endTimeUnit).endOf('day')
        : defaultEnd;
};
export const getDefaultDateRangeFilter = ({ options, isDashboard, startValue, startTimeUnit, endValue, endTimeUnit, startKey, }) => {
    const defaultEnd = moment().endOf('day');
    if (isDashboard) {
        return Object.assign({ start_date: moment().subtract(startValue, startTimeUnit).startOf('day'), end_date: endValue && endTimeUnit
                ? moment().add(endValue, endTimeUnit).endOf('day')
                : defaultEnd }, startKey);
    }
    return Object.assign({ start: options === 'object'
            ? moment().subtract(startValue, startTimeUnit).startOf('day')
            : moment()
                .subtract(startValue, startTimeUnit)
                .startOf('day')
                .toISOString(), end: options === 'object'
            ? getEndDateRangeValue({ endValue, endTimeUnit, defaultEnd })
            : defaultEnd.toISOString() }, startKey);
};
